import { Params } from '@angular/router';
import { IFilterGroup } from './map-odata-filters';
import { ISort } from './sort';

export enum RouteMode {
  Add = 'add',
  Edit = 'edit',
}

export const routeParam = {
  add: { mode: RouteMode.Add, id: undefined },
  clear: { mode: undefined, id: undefined },
  edit: (id: unknown) => ({ mode: RouteMode.Edit, id }),
};

export const routeParamWithPrefix = (prefix = '') => {
  if (prefix !== '') {
    prefix += '_';
  }

  const prefixedMode = `${prefix}mode`;
  const prefixedId = `${prefix}id`;

  return {
    add: {
      [prefixedMode]: RouteMode.Add,
      [prefixedId]: undefined,
    } as { [x: string]: RouteMode | undefined },
    clear: {
      [prefixedMode]: undefined,
      [prefixedId]: undefined,
    } as { [x: string]: undefined },
    edit: (id: unknown) => ({
      [prefixedMode]: RouteMode.Edit,
      [prefixedId]: id,
    }),
  };
};

export interface IAddParams {
  mode: RouteMode.Add;
}

export interface IEditParams {
  mode: RouteMode.Edit;
  id: string;
}

export interface IQueryParams<T> {
  page: number;
  size: number;
  sort?: ISort<T>;
  filters?: IFilterGroup;
}

export const mapToAddEditParams = (
  params: Params,
  prefix: string
): IAddParams | IEditParams | undefined => {
  if (prefix !== '') {
    prefix += '_';
  }

  const mode = params[`${prefix}mode`] as string | undefined;
  const id = params[`${prefix}id`] as string | undefined;

  if (mode === RouteMode.Edit) {
    if (typeof id !== 'string') {
      throw new Error(`query param '${prefix}mode=edit' but no '${prefix}id' param was given`);
    }

    return { mode, id };
  }

  if (mode === RouteMode.Add) {
    return { mode };
  }

  return undefined;
};

export const handleAddEditParams = <TAdd, TEdit>(
  params: IAddParams | IEditParams,
  addCallback?: () => TAdd,
  editCallback?: (editId: string) => TEdit
): TAdd | TEdit | undefined => {
  if (params.mode === RouteMode.Add && !!addCallback) {
    return addCallback();
  }

  if (params.mode === RouteMode.Edit && params.id && !!editCallback) {
    const editId = params.id;

    return editCallback(editId);
  }

  return undefined;
};
